/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Media_Type_CallInputs */

const en_enum_media_type_call = /** @type {(inputs: Enum_Media_Type_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call`)
};

const de_enum_media_type_call = /** @type {(inputs: Enum_Media_Type_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call`)
};

/**
* | output |
* | --- |
* | "Call" |
*
* @param {Enum_Media_Type_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_media_type_call = /** @type {((inputs?: Enum_Media_Type_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Media_Type_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_media_type_call(inputs)
	return de_enum_media_type_call(inputs)
});